export default {
  wideColumn: {
    xs: { span: 22, offset: 1 },
    sm: { span: 22, offset: 1 },
    md: { span: 20, offset: 2 },
    lg: { span: 18, offset: 3 },
    xl: { span: 14, offset: 5 }
  },
  thinColumn: {
    xs: { span: 22, offset: 1 },
    sm: { span: 20, offset: 2 },
    md: { span: 14, offset: 5 },
    lg: { span: 10, offset: 7 },
    xl: { span: 8, offset: 8 }
  }
}
